import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactsCache, {
  type ContactCustomPropertyInfo,
  isGroupsContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import type { OptionAndCount } from '.';

interface ComponentArgs {
  propertyInfo: ContactCustomPropertyInfo;
  onReorderOptions: () => void;
  onRenameOption: (optionAndCount: OptionAndCount) => void;
  onMergeOption: (optionAndCount: OptionAndCount) => void;
  onDeleteOption: (optionAndCount: OptionAndCount) => void;
  onClose: () => void;
}

export default class ContactDetailsPropertiesCustomPropertyEditOptionsModalShowOptionsComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;

  get hasMoreThanOneOption() {
    return this.propertyOptionsAndCount.length > 1;
  }

  get isGroupsProperty() {
    return isGroupsContactCustomPropertyInfo(this.args.propertyInfo);
  }

  get contactsFilterPropertyName() {
    if (this.isGroupsProperty) {
      return 'contactGroups';
    } else {
      return `contact_custom_${this.args.propertyInfo.l}`;
    }
  }

  get propertyOptionsAndCount(): OptionAndCount[] {
    let propertyLabel = this.args.propertyInfo.l;
    if (this.isGroupsProperty) {
      return this.args.propertyInfo.o!.map((option) => {
        return {
          option,
          count: this.contactsCache.contacts.filter((x) =>
            x.groups?.includes(option),
          ).length,
        };
      });
    } else {
      return this.args.propertyInfo.o!.map((option) => {
        return {
          option,
          count: this.contactsCache.contacts.filter(
            (x) => x.customPropertiesByLabel[propertyLabel]?.v?.[option],
          ).length,
        };
      });
    }
  }
}
